import * as yup from "yup";

export const advisoryFormSchema = yup.object({
  wantsInsurance: yup
    .boolean()
    .nullable()
    .required("Réponse requise.")
    .oneOf([true], "Pour continuer, vous devez souhaiter souscrire une assurance."),
  usageType: yup
    .string()
    .nullable()
    .required("Sélectionnez un type d'usage.")
    .oneOf(["personal", "professional"], "Sélectionnez un type d'usage."),
  offerType: yup
    .string()
    .nullable()
    .required("Sélectionnez un type d'offre.")
    .oneOf(["mobile_protection", "connect_protection"], "Sélectionnez un type d'offre."),
  risks: yup.array().min(1, "Sélectionnez au moins un risque."),
  hasExistingInsurance: yup.mixed().nullable().required("Réponse requise."),
  existingInsuranceReason: yup
    .string()
    .nullable()
    .when("hasExistingInsurance", {
      is: (v) => v === true,
      then: (s) => s.required("Sélectionnez une raison."),
      otherwise: (s) => s.notRequired(),
    }),
  existingInsuranceReasonOtherText: yup
    .string()
    .nullable()
    .when("existingInsuranceReason", {
      is: (reason) => reason === "other",
      then: (s) => s.required("Précisez votre raison.").trim().min(1, "Précisez votre raison."),
      otherwise: (s) => s.notRequired(),
    }),
  electronicDevicesValue: yup
    .string()
    .nullable()
    .when("offerType", {
      is: (v) => v === "connect_protection",
      then: (s) => s.required("Sélectionnez une valeur."),
      otherwise: (s) => s.notRequired(),
    }),
});

export const RISK_OPTIONS = [{ value: "breakage" }, { value: "oxidation" }, { value: "theft" }, { value: "breakdown" }];
export const USAGE_TYPE_OPTIONS = [{ value: "personal" }, { value: "professional" }];
export const ELECTRONIC_DEVICES_VALUE_OPTIONS = [
  { value: "less_than_500" },
  { value: "five_hundred_to_one_thousand" },
  { value: "one_thousand_to_three_thousand" },
  { value: "three_thousand_to_five_thousand" },
];
export const WANTS_INSURANCE_OPTIONS = [{ value: true }, { value: false }];
export const HAS_EXISTING_INSURANCE_OPTIONS = [{ value: true }, { value: false }];
export const EXISTING_INSURANCE_REASON_OPTIONS = [
  { value: "better_coverage" },
  { value: "better_price" },
  { value: "unsatisfied" },
  { value: "other" },
];

export const defaultAdvisory = () => ({
  wantsInsurance: null,
  usageType: null,
  risks: [],
  offerType: null,
  hasExistingInsurance: undefined,
  existingInsuranceReason: null,
  existingInsuranceReasonOtherText: "",
  electronicDevicesValue: null,
  recommendedOffer: null,
  recommendedOfferId: null,
});
